import { AxiosResponse } from 'axios';

import client from '../../lib/service/partner.service';
import { Company } from './companies.types';

type GetResponse = { company: Company };

const COMPANIES = (companyId: string) => `/v1/companies/${companyId}`;

export const getCompany = async (companyId: string) => {
  const response = await client.get<null, AxiosResponse<GetResponse>>(
    COMPANIES(companyId),
  );
  return response.data.company;
};
